import Routes from "./Router/Index";

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
